import { render, staticRenderFns } from "./UsersAddUpdate.vue?vue&type=template&id=3c72f480"
import script from "./UsersAddUpdate.vue?vue&type=script&lang=js"
export * from "./UsersAddUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports